import React, { FC } from "react";
import { Radio, Space, Form, FormInstance } from "antd";
import { Permission, usePermissionCheck } from "~/hooks";
import { useTaxonomyLabel } from "~/context/taxonomy-context";

export enum MatterStartingOptions {
  None = "none",
  Template = "template",
  HistoricalMatter = "historicalMatter",
  Bespoke = "bespoke",
  MultiDisciplinary = "multiDisciplinary",
}

type Props = {
  form: FormInstance;
  showMultiDisc: boolean;
};
export const StartingPointSelection: FC<Props> = ({ form, showMultiDisc }) => {
  const taxonomy = useTaxonomyLabel();
  const betaFeatures = usePermissionCheck([Permission.BETA_FEATURES]);
  return (
    <Form form={form} layout="vertical">
      <Form.Item
        label="Please select how you would like to create your matter"
        name="startingPoint"
        rules={[
          {
            required: true,
            message: "Please select starting point for your matter",
          },
        ]}
      >
        <Radio.Group>
          <Space direction="vertical">
            <Radio value={MatterStartingOptions.Template}>Using a {taxonomy.Template}</Radio>
            <Radio value={MatterStartingOptions.Bespoke}>Single {taxonomy.PracticeArea}</Radio>
            {showMultiDisc && betaFeatures && (
              <Radio value={MatterStartingOptions.MultiDisciplinary}>
                Multi {taxonomy.PracticeArea}
              </Radio>
            )}
            <Radio value={MatterStartingOptions.HistoricalMatter}>
              From a historical VPD proposal
            </Radio>
          </Space>
        </Radio.Group>
      </Form.Item>
    </Form>
  );
};
